import Vue from 'vue'

let hub = new Vue()

export let eventHub = hub



// WEBPACK FOOTER //
// ./src/utils/EventHub.js